import "./HamburgerMenu.css";
import "../../index.css"
import ButtonCover from "../ButtonCover/ButtonCover";

const HamburgerMenu = ({onClick, clr, bg}) => {

  return (
        <ButtonCover onClick={onClick} bg={bg && bg } >
          <div className="hamburger-icon">
          <i className={`fa-solid fa-bars ${clr && clr}`}></i>
          </div>
        </ButtonCover>
  );
};

export default HamburgerMenu;